import { type FormEventHandler, useState } from 'react';
import FormHeading from '@/components/FormHeading';
import TextField from '@/components/inputs/TextField';
import Button from '@/components/Button';
import TextLink from '@/components/TextLink';
import { classes } from './utils';

export type ResetPasswordFormProps = {
  isResettingPassword: boolean;
  onReturnToLogin: () => void;
  onSubmit: (newPassword: string) => void;
};

export default function ResetPasswordForm({
  isResettingPassword,
  onReturnToLogin,
  onSubmit,
}: ResetPasswordFormProps) {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const isEnabled =
    newPassword.trim().length >= 8 && newPassword === confirmPassword;

  const handleSubmit: FormEventHandler<HTMLFormElement> = (e) => {
    e.preventDefault();
    if (isEnabled && !isResettingPassword) onSubmit(newPassword.trim());
  };

  return (
    <form
      className={classes.form}
      name="reset-password"
      onSubmit={handleSubmit}>
      <FormHeading
        className={classes.heading}
        title="Set a new password"
        subtitle="Choose a new password for your account. It should be at least 8 characters long."
      />
      <TextField
        autoFocus
        className={classes.newPassword}
        type="password"
        label="New Password"
        autoComplete="new-password"
        value={newPassword}
        onChange={setNewPassword}
      />
      <TextField
        className={classes.confirmPassword}
        type="password"
        label="Confirm Password"
        autoComplete="new-password"
        value={confirmPassword}
        onChange={setConfirmPassword}
      />
      <Button
        busy={isResettingPassword}
        disabled={!isEnabled}
        busyLabel="Resetting"
        type="submit">
        Reset
      </Button>
      <div className={classes.backWrapper}>
        <TextLink onClick={onReturnToLogin}>Back to login</TextLink>
      </div>
    </form>
  );
}
